<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :triggerSave.sync="triggerSave"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Create",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      active_check:true,
      users_clubs_id : '',
      time_zone_local : moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted () {
    console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editAppoinments' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_APPOINMENTS);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-appoinments' });
    },
    UpdateActive(key){
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if(key == 'lock'){
        this.active_check = false
      }else{
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': {'_eq': this.$route.params.id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        if(key == 'lock'){
          var query_t =  `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async saveData(params) {
      // console.log("params",params)

      //M dd, yy HH:mm
      var date_format_push = params.date.format('MMM DD, YYYY HH:mm');
      var date_format_push_da = moment(params.date)
      .locale('da')
      .format('[d.] D. MMMM YYYY [kl.] HH.mm');
      let objects = {
        property_id: params.property_id,
        date: params.date.format("YYYY-MM-DD HH:mm:ss"),
        title: params.title,
        title_en: params.title_en,
        description_en: params.description_en,
        description_dn: params.description_dn,
        updated_at: moment.tz(new Date(), this.time_zone_local),
        updated_by: this.$store.getters.user,
        is_use_en: params.is_use_en,
      }
      if (params.is_use_en == false) {
        objects.description_en = objects.description_dn;
        objects.title_en = objects.title;
      }
      console.log("objectsobjectsobjectsobjectsobjectsobjects",objects);
      this.triggerSave = false;
      //getListAdminProperty
      var where_key = {
          property_id : {_eq : params.property_id},
        };
      var data_list_user = await this.$CoreService.getListAdminProperty(where_key);
      var list_user = data_list_user.list;
      var list_user_id = [];
      for (let i = 0; i < list_user.length; i++) {
        list_user_id.push(list_user[i].uid)
      } 
      var property_name =params.property_name;
      var params_noti ={
                title:"",
                content:"",
                short_content:`${property_name} Hej! Dette er en påmindelse om dit møde ${date_format_push_da}. Du finder alle mødedetaljerne i kalenderen. Vel mødt! `,
                short_content_noti:`<b>${property_name}</b> Hej! Dette er en påmindelse om dit møde ${date_format_push_da}. Du finder alle mødedetaljerne i kalenderen. Vel mødt! `,
                is_use_en:true,
                title_en:"",
                content_en:"",
                short_content_en:`${property_name} Hi there! This is just a quick reminder about your meeting on ${date_format_push}. Remember to check your calendar for the details. See you then! `,
                short_content_noti_en:`<b>${property_name}</b> Hi there! This is just a quick reminder about your meeting on ${date_format_push}. Remember to check your calendar for the details. See you then! `,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.PROPERTY_DETAIL,
                uid:null,
                multi_uid:list_user_id,
                object_id:params.property_id,
                is_admin:false,
                key_noti:3,
              }

      if(this.mode == 'add'){
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        await this.$apollo.mutate({
            mutation: DataServices.insertData('appoinment'),
            variables: {
              objects: objects
            }
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              if(list_user_id.length > 0){
               await this.$CoreService.sendNoti(params_noti);
              }
              this.redirectEdit();
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }else{
        // params_noti.short_content = `${property_name} Hej! Dette er en påmindelse om dit møde ${date_format_push_da}. Du finder alle mødedetaljerne i kalenderen. Vel mødt!`;
        // params_noti.short_content_noti = `<b>${property_name}</b> Hej! Dette er blot en hurtig besked om, at dit møde er blevet flyttet til ${date_format_push}. Husk at tjekke din kalender for de opdaterede detaljer. `;
        // params_noti.short_content_en = `${property_name} Hi there! This is just a quick heads-up—your meeting has been moved to ${date_format_push}. Be sure to check your calendar for the updated details. `;
        // params_noti.short_content_noti_en = `<b>${property_name}</b> Hi there! This is just a quick heads-up—your meeting has been moved to ${date_format_push}. Be sure to check your calendar for the updated details. `;
        // var user_id = this.$route.params.id;
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': {'_eq': this.models.id}
          }
        }
        await this.$apollo.mutate({
            mutation: DataServices.updateData('appoinment'),
            variables: variables
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              if(list_user_id.length > 0){
                await this.$CoreService.sendNoti(params_noti);
              }
              this.redirectEdit();
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }
      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-appoinments'};
      that.$commonFuction.is_loading(false);
      that.$router.push(router_back);
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('appoinment',{"fields" : `id title title_en property{id code name address booking{id} part {id part order_booking user {id fullname email}}} date description_en description_dn is_use_en`}),
        variables: {
          where_key: {
            id: {'_eq': id},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    /* margin-bottom: 16px; */
    padding-bottom: 10px;
    /* border-bottom: 1px solid #EEEEEE; */
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>